import React from 'react';
import { motion } from 'framer-motion';
import { aboutAnimations } from '../helpers/animation';
import { useScroll } from '../helpers/scrollAnimations';

const About = () => {
	const [element, controls] = useScroll();
	return (
		<motion.div
			animate={controls}
			ref={element}
			initial="hidden"
			variants={aboutAnimations}
			id="about"
			className="section about"
		>
			<motion.div className="about-me">
				<h2>About Me</h2>
				<p>
					I am 19 years old. I'm from Lalitpur and aspire to be a web developer.
					I have experience working with
					<span className="yellow"> Javascript</span> using
					<span className="blue"> React</span> developing websites. I also have
					knowledge of <span className="blue">Java</span> and{' '}
					<span className="blue">C</span>. According to my passions, I am a
					cinephile, melomaniac and a writer. I am positive of what lies ahead
					of me.
				</p>
			</motion.div>
		</motion.div>
	);
};

export default About;
